import { UserByIdQueryResult } from '@shared/interfaces/rbs/user-by-id-query-result.interface';
import { UserByIdVariables } from '@shared/interfaces/rbs/user-by-id-variables.interface';
import { gql } from 'apollo-angular';

export const GET_USER_BY_ID = gql<UserByIdQueryResult, UserByIdVariables>`
  query GetUserById($id: UUID!) {
    userById(id: $id) {
      accessFailedCount
      dateUpdated
      email
      emailConfirmed
      firstName
      id
      isPasswordExpired
      lastName
      lockoutEnabled
      lockoutEnd
      normalizedEmail
      normalizedUserName
      phoneExtension
      phoneNumber
      phoneNumberConfirmed
      prefix
      suffix
      twoFactorEnabled
      userName
      usersInOrg {
        claimPrefix
        dateCreated
        dateExpire
        dateStart
        dateUpdated
        displayOrder
        id
        isStaff
        orgId
        userId
        org {
          claimPrefix
          dateCreated
          dateExpire
          dateStart
          dateUpdated
          id
          orgCode
          orgName
          orgType
          requireMFA
          tpaRule
          tpaRuleFilter
        }
        orgUsersForOrgRole {
          applicationServiceId
          claimPrefix
          dateCreated
          dateExpire
          dateStart
          id
          orgId
          roleOrgId
          userOrgId
          orgRole {
            claimPrefix
            dateCreated
            dateExpire
            dateStart
            id
            orgId
            orgInServiceId
            serviceRoleId
            serviceRole {
              applicationServiceId
              claimPrefix
              copiedFromTemplateId
              dateCreated
              dateExpire
              dateStart
              id
              isTemplate
              name
            }
          }
        }
      }
    }
  }
`;
